import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import NextBestActionContext from '~/context/home/NextBestActionContext';
import feedItemMapper from './feedItemMapper';
import LoadingCard from './LoadingCard';
import getHighestPriorityPipFeedItem from '../utils/getHighestPriorityPipFeedItem';

export default function StatusCard() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    actions: { data, isLoaded, hasError }
  } = useContext(NextBestActionContext);

  if (!isLoaded) return <LoadingCard />;

  const feedItems = data?.feedItems || [];
  const feedItemToDisplay = getHighestPriorityPipFeedItem(feedItems);

  if (data?.isError || hasError || !feedItemToDisplay) {
    trackEvent('Order Status Card Load Failed', data?.errorEventPayload);

    return null;
  }

  return <>{feedItemMapper(feedItemToDisplay)}</>;
}
